<template>
  <v-container>
    <div class="d-flex flex-row flex-wrap align-center">
      <PageTitle text="Card Transactions" class="font d-flex flex-column" />
      <v-btn
        small
        icon
        :loading="allTransactionsLoading"
        fab
        @click.stop="refreshPage"
        class="ml-2"
      >
        <i class="material-icons-outlined">refresh</i>
      </v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        dense
        solo-inverted
        hide-details
        placeholder="Search by record no, auth no, or reference"
        class="font font-size-sm mr-4"
        style="max-width: 350px;"
      ></v-text-field>
    </div>

    <v-row align="center" justify="center">
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="filteredTransactions"
          :loading="allTransactionsLoading"
          :server-items-length="allTransactionsTotal"
          :options.sync="options"
          :search="search"
          class="box-shadow-light font font-weight-medium"
          :footer-props="{
            itemsPerPageOptions: [10, 20, 50, 100]
          }"
        >
          <template #item.salesDate="{ item }">
            <span class="font-weight-medium">{{ item.salesDate }}</span>
          </template>

          <template #item.cardCategoryName="{ item }">
            <v-chip small label color="primary" class="white--text">
              {{ item.cardCategoryName }}
            </v-chip>
          </template>

          <template #item.amount="{ item }">
            <span class="font-weight-bold">{{
              item.amount | currencyFormat
            }}</span>
          </template>

          <template #item.discount="{ item }">
            <span v-if="item.discount">{{
              item.discount | currencyFormat
            }}</span>
            <span v-else class="grey--text">--</span>
          </template>

          <template #item.cumulativeMonthlyTotal="{ item }">
            <span class="font-weight-medium">{{
              item.cumulativeMonthlyTotal | currencyFormat
            }}</span>
          </template>

          <template #item.isApproved="{ item }">
            <v-chip
              :color="item.isApproved ? 'success' : 'warning'"
              small
              label
              class="white--text"
            >
              {{ item.isApproved ? "Approved" : "Pending" }}
            </v-chip>
          </template>

        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PageTitle from "../../components/PageTitle";
import { currencyFormat } from "@/filters/currencyFormat";

export default {
  name: "CardTransactionsList",
  components: { PageTitle },
  data() {
    return {
      search: "",
      options: {
        page: 1,
        itemsPerPage: 20
      },
      headers: [
        { text: "Sales Date", value: "salesDate", sortable: true },
        { text: "Card Category", value: "cardCategoryName", sortable: true },
        { text: "Record No", value: "recordNo", sortable: false },
        { text: "Auth No", value: "authNo", sortable: false },
        { text: "Amount", value: "amount", sortable: true },
        { text: "Discount", value: "discount", sortable: false },
        { text: "Reference", value: "reference", sortable: false },
        {
          text: "Monthly Cumulative",
          value: "cumulativeMonthlyTotal",
          sortable: true
        },
        { text: "Approved", value: "isApproved", sortable: true }
      ]
    };
  },
  computed: {
    allTransactions() {
      return this.$store.getters["cards/getAllTransactions"];
    },
    allTransactionsTotal() {
      return this.$store.getters["cards/getAllTransactionsTotal"];
    },
    allTransactionsLoading() {
      return this.$store.getters["cards/getAllTransactionsLoading"];
    },
    filteredTransactions() {
      if (!this.search) return this.allTransactions;
      const query = this.search.toLowerCase();
      return this.allTransactions.filter(
        t =>
          (t.recordNo && t.recordNo.toLowerCase().includes(query)) ||
          (t.authNo && t.authNo.toLowerCase().includes(query)) ||
          (t.reference && t.reference.toLowerCase().includes(query))
      );
    }
  },
  filters: {
    currencyFormat
  },
  watch: {
    options: {
      handler() {
        this.loadTransactions();
      },
      deep: true
    }
  },
  methods: {
    async loadTransactions() {
      await this.$store.dispatch("cards/loadAllTransactions", {
        page: this.options.page,
        limit: this.options.itemsPerPage
      });
    },
    async refreshPage() {
      this.options.page = 1;
      await this.loadTransactions();
    }
  },
  async created() {
    await this.loadTransactions();
  }
};
</script>

<style scoped></style>
